import { render } from "./ModalProfile.vue?vue&type=template&id=03231900"
import script from "./ModalProfile.vue?vue&type=script&lang=js"
export * from "./ModalProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__